var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmptyAlerts = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaeaf3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#babed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9399b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alerts",
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7060",
    "data-name": "Ellipse 7060",
    cx: 75,
    cy: 75,
    r: 75,
    transform: "translate(0 0.1)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35331",
    "data-name": "Group 35331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35328",
    "data-name": "Group 35328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63301",
    "data-name": "Path 63301",
    d: "M43.229,25h63.542a6.11,6.11,0,0,1,6.11,6.11v87.982a6.11,6.11,0,0,1-6.11,6.11H43.229a6.11,6.11,0,0,1-6.11-6.11V31.11A6.11,6.11,0,0,1,43.229,25Z",
    transform: "translate(150 150.201) rotate(180)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35329",
    "data-name": "Group 35329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63302",
    "data-name": "Path 63302",
    d: "M107.993,120.515H42.007a.2.2,0,0,1-.2-.2V29.888a.2.2,0,0,1,.2-.2h65.986a.2.2,0,0,1,.2.2v90.425A.2.2,0,0,1,107.993,120.515Zm-65.784-.4h65.582V30.09H42.209Z",
    fill: "#eaeaf3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35330",
    "data-name": "Group 35330"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18294",
    "data-name": "Rectangle 18294",
    width: 18.329,
    height: 2.444,
    transform: "translate(83.399 35.998)",
    fill: "#969bb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18295",
    "data-name": "Rectangle 18295",
    width: 18.329,
    height: 2.444,
    transform: "translate(83.399 40.886)",
    fill: "#b6bacc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18296",
    "data-name": "Rectangle 18296",
    width: 18.329,
    height: 2.444,
    transform: "translate(83.399 45.773)",
    fill: "#d1d5e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18297",
    "data-name": "Rectangle 18297",
    width: 54.988,
    height: 2.444,
    transform: "translate(46.74 54.327)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18298",
    "data-name": "Rectangle 18298",
    width: 54.988,
    height: 2.444,
    transform: "translate(46.74 61.659)",
    fill: "#eaeaf3"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18299",
    "data-name": "Rectangle 18299",
    width: 54.988,
    height: 2.444,
    transform: "translate(47.506 104.35)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18300",
    "data-name": "Rectangle 18300",
    width: 54.988,
    height: 2.444,
    transform: "translate(47.506 111.682)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18301",
    "data-name": "Rectangle 18301",
    width: 29.553,
    height: 2.444,
    transform: "translate(60.224 97.019)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63303",
    "data-name": "Path 63303",
    d: "M86.372,97.019H63.628l3.488-17.9A3.248,3.248,0,0,1,70.3,76.5h9.391a3.248,3.248,0,0,1,3.188,2.627Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18302",
    "data-name": "Rectangle 18302",
    width: 5.139,
    height: 2.444,
    transform: "translate(76.222 67.461) rotate(90)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18303",
    "data-name": "Rectangle 18303",
    width: 7.666,
    height: 2.444,
    transform: "translate(76.222 91.796) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18304",
    "data-name": "Rectangle 18304",
    width: 3.688,
    height: 2.444,
    transform: "translate(87.616 72.903) rotate(135)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18305",
    "data-name": "Rectangle 18305",
    width: 3.688,
    height: 2.444,
    transform: "translate(64.113 71.163) rotate(45)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35332",
    "data-name": "Group 35332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63304",
    "data-name": "Path 63304",
    d: "M75,85.914a1.779,1.779,0,1,1-1.779,1.779A1.781,1.781,0,0,1,75,85.914m0-3a4.779,4.779,0,1,0,4.779,4.779A4.779,4.779,0,0,0,75,82.914Z",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyAlerts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-alerts.3ed2eb86.svg";
export { ForwardRef as ReactComponent };